module.exports = __webpack_public_path__ + "assets/img/lock.d607328e.svg";